import { render, staticRenderFns } from "./PersonalMessage.vue?vue&type=template&id=08380134&scoped=true&"
import script from "./PersonalMessage.vue?vue&type=script&lang=js&"
export * from "./PersonalMessage.vue?vue&type=script&lang=js&"
import style0 from "./PersonalMessage.vue?vue&type=style&index=0&id=08380134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08380134",
  null
  
)

export default component.exports